import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const RappersTable = ({ rappers, onDelete }) => {
  const [search, setSearch] = useState('');

  const filteredRappers = search.trim()
    ? rappers.filter((r) => {
        const q = search.toLowerCase();
        return (
          (r.display_name || '').toLowerCase().includes(q) ||
          (r.username || '').toLowerCase().includes(q)
        );
      })
    : rappers;

  if (rappers.length === 0) {
    return (
      <div className="bg-battle-gray rounded-lg overflow-hidden border border-army/20">
        <div className="p-12 text-center text-gray-500">
          No rappers yet.
        </div>
      </div>
    );
  }

  return (
    <div className="bg-battle-gray rounded-lg overflow-hidden border border-army/20">
      {/* Search Input */}
      <div className="p-4 border-b border-army/15">
        <input
          type="text"
          placeholder="Search rappers..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full sm:w-80 px-4 py-2 bg-battle-dark border border-army/40 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-brand-yellow/60 transition-colors"
          data-testid="rappers-search-input"
        />
      </div>
      <div className="overflow-x-auto">
      <table className="w-full min-w-[600px]">
        <thead className="bg-battle-dark">
          <tr>
            <th className="text-left p-4 text-gray-400 font-semibold">Name</th>
            <th className="text-left p-4 text-gray-400 font-semibold">Username</th>
            <th className="text-left p-4 text-gray-400 font-semibold">Battles</th>
            <th className="text-left p-4 text-gray-400 font-semibold">Created At</th>
            <th className="text-right p-4 text-gray-400 font-semibold">Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredRappers.length === 0 ? (
              <tr>
                <td colSpan="5" className="p-8 text-center text-gray-500">
                  No rappers match your search.
                </td>
              </tr>
            ) : null}
          {filteredRappers.map((rapper) => (
            <tr
              key={rapper.id}
              className="border-t border-army/10 hover:bg-gray-800/50 transition-colors cursor-pointer"
              data-testid={`rapper-row-${rapper.id}`}
            >
              <td className="p-4">
                <Link
                  to={`/artist/${rapper.id}`}
                  className="text-white hover:text-brand-yellow transition-colors"
                >
                  {rapper.display_name || rapper.username}
                </Link>
              </td>
              <td className="p-4 text-gray-400">{rapper.username}</td>
              <td className="p-4">
                <span className="px-2 py-1 bg-battle-dark rounded text-sm text-gray-300">
                  {rapper.video_count || 0}
                </span>
              </td>
              <td className="p-4 text-gray-400">
                {new Date(rapper.created_at).toLocaleDateString()}
              </td>
              <td className="p-4 text-right">
                <button
                  onClick={() => onDelete(rapper.id)}
                  className="text-red-400 hover:text-red-300"
                  data-testid={`delete-rapper-${rapper.id}`}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default RappersTable;
